import { observer } from 'mobx-react-lite'
import { quickApplyStore } from '~/features/quick-apply/quick-apply.store'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { NotifyDialog } from '~/components/notify'
import React from 'react'
import { logClickEvent } from '~/common/tracking/event-client.tracking'
import { COMMON_EVENT_CLICK_TRACKING } from '~/common/constants/tracking.constant'

export const SuccessApplyDialog = observer(() => {
	const { successApplyDialog, setSuccessApplyDialog, currentJob } = quickApplyStore
	const { t } = useTranslation()
	const isSymplerJob = currentJob?.atsSource === 'symplr'
	return (
		<NotifyDialog
			eventName={COMMON_EVENT_CLICK_TRACKING.applicationSentToRecruiterScreen}
			onClose={() => {
				setSuccessApplyDialog(false)
				logClickEvent(COMMON_EVENT_CLICK_TRACKING.closeBtnApplyForThisJob)
			}}
			showButtonClose={true}
			open={successApplyDialog}
			okText="I got it"
			onOk={() => {
				setSuccessApplyDialog(false)
				logClickEvent(COMMON_EVENT_CLICK_TRACKING.iGotItBtnApplicationSentToRecruiter)
			}}
			title={isSymplerJob ? t('$MESSAGES.QUICK_APPLY_SL_SUCCESS') : t('$MESSAGES.QUICK_APPLY_SUCCESS')}
			children={isSymplerJob ? t('$MESSAGES.QUICK_APPLY_SUCCESS_DES_NO_LTO') : t('$MESSAGES.QUICK_APPLY_SUCCESS_DES')}
		/>
	)
})
